// src/components/AssetFilterButtons.jsx
import React from 'react';

export default function AssetFilterButtons({ selected, onSelect }) {
  return (
    <div className="d-flex mb-3">
      <button
        className={`btn rounded-pill me-2 ${selected === 'active' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onSelect('active')}
      >
        Active tasks
      </button>
      <button
        className={`btn rounded-pill me-2 ${selected === 'valid' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onSelect('valid')}
      >
        Valid access
      </button>
      <button
        className={`btn rounded-pill ${selected === 'history' ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={() => onSelect('history')}
      >
        History
      </button>
    </div>
  );
}
